import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { isSmallScreen } from "metabase/lib/dom";
import HomeLayout from "../../containers/HomeLayout";
import HomeContent from "../../containers/HomeContent";

export interface HomePageProps {
  onOpenNavbar: () => void;
}

const HomePage = ({ onOpenNavbar }: HomePageProps): JSX.Element => {
  const history = useHistory();
  useEffect(() => {

    if (!isSmallScreen()) {
      onOpenNavbar();
    }
  }, [onOpenNavbar]);
  history.push('/collection/root')

  return (
    <HomeLayout>
      <HomeContent />
    </HomeLayout>
  );
};

export default HomePage;
